export default {
  searchText(state) {
    return state.searchText;
  },
  listOptions(state) {
    return state.listOptions;
  },
  stringFilter(state) {
    const searchText = state.searchText ? state.searchText.toLowerCase() : '';
    return `descricao like '%${searchText}%' or codigoInterno like '%${searchText}%'`;
  },
};
